// extracted by mini-css-extract-plugin
export default {"container":"AD7rS","slide":"_3i79N","postWrapper":"_74qu4","withoutFooter":"FH-ji","separator":"_168Wt"};